/** Number of placeholder rows shown while the tagger list loads. */
export const SKELETON_TAGGER_ROWS = 3;
